// test2245
(2245 && 0);
